/**
 * @typedef {(ATTACK | IDLE)} TypeAnimation An animation.
 */

/**
 * The 'ATTACK' animation.
 * @type {'attack'}
 * @constant
 */
const ATTACK = 'attack';

/**
 * The 'IDLE' animation.
 * @type {'idle'}
 * @constant
 */
const IDLE = 'idle';

export {

    ATTACK,
    IDLE
};
